import * as React from "react";
import { forwardRef } from "react";
const SvgEventCategoryAlert = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M16.0001 29c7.1797 0 13-5.8203 13-13s-5.8203-13-13-13-13 5.8203-13 13 5.8203 13 13 13Zm0 3c8.8365 0 16-7.1634 16-16s-7.1635-16-16-16c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.0001 23.5c0 1.1046-.8955 2-2 2-1.1046 0-2-.8954-2-2s.8954-2 2-2c1.1045 0 2 .8954 2 2Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M16.0001 6.5c.8284 0 1.5.6716 1.5 1.5v9.5c0 .8284-.6716 1.5-1.5 1.5-.8285 0-1.5-.6716-1.5-1.5V8c0-.8284.6715-1.5 1.5-1.5Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgEventCategoryAlert);
export default ForwardRef;
